import { createDomain } from "effector";

export const QuoteDomain = createDomain();

export const httpFetchVolumeQuote = QuoteDomain.effect();
export const httpFetchFreightQuote = QuoteDomain.effect();
